import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Attach = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M18.3333 6C15.9401 6 14 7.9401 14 10.3333V27C14 30.866 17.134 34 21 34C24.866 34 28 30.866 28 27V11.1538C28 10.6016 28.4477 10.1538 29 10.1538C29.5523 10.1538 30 10.6016 30 11.1538V27C30 31.9706 25.9706 36 21 36C16.0294 36 12 31.9706 12 27V10.3333C12 6.83553 14.8355 4 18.3333 4C21.8311 4 24.6667 6.83553 24.6667 10.3333V24.641C24.6667 26.6661 23.025 28.3077 21 28.3077C18.975 28.3077 17.3333 26.6661 17.3333 24.641V11.1538C17.3333 10.6016 17.781 10.1538 18.3333 10.1538C18.8856 10.1538 19.3333 10.6016 19.3333 11.1538V24.641C19.3333 25.5615 20.0795 26.3077 21 26.3077C21.9205 26.3077 22.6667 25.5615 22.6667 24.641V10.3333C22.6667 7.9401 20.7266 6 18.3333 6Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Attach;
